import React from "react";
import { DotLegalCheckbox } from "@dotlegal/dotlegal-ui-components";
import { DotLegalMultiSelect, DotLegalDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { useUpdateSystemTemplateHook } from "./UpdateSystemTemplateDialog.hooks";

export interface IUpdateSystemTemplateInfoDialogProps {
    systemId: string;
    closeDialog: () => void;
}

function UpdateSystemTemplateDialog(props: IUpdateSystemTemplateInfoDialogProps) {
    const { translateString } = useTranslation();
    const { isLoading, systemTypesSelectOptions, saveTemplateInfo, inProgress, model, setModel } = useUpdateSystemTemplateHook(props);

    return (
        <DotLegalDialog
            inProgress={inProgress}
            size="sm"
            buttonOkText={translateString("save")}
            header={""}
            open
            onDialogClose={() => props.closeDialog()}
            onOkClick={() => saveTemplateInfo()}
            isLoading={isLoading}
        >
            <DotLegalMultiSelect
                isLoading={isLoading}
                options={systemTypesSelectOptions}
                chosenOptions={model?.systemTypes!}
                placeholder={"Brancher"}
                label={"Brancer"}
                onChange={(areas) => {
                    let tempModel = { ...model! };
                    tempModel.systemTypes = areas;
                    setModel(tempModel);
                }}
                noOptionsLabel={translateString("noOptions")}
            />

            <DotLegalCheckbox
                label={"Mest populær?"}
                checked={model?.mostPopular ? model.mostPopular : false}
                onChange={(value) => {
                    let tempModel = { ...model! };
                    tempModel.mostPopular = value;
                    setModel(tempModel);
                }}
            />
        </DotLegalDialog>
    );
}

export default UpdateSystemTemplateDialog;
